
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as fpTsoQy5_bK285kPqz4y_5yvcR7BBPApoK1Cp8XvV_gaEMeta } from "/Users/chris/Projects/autoz/dealerme/pages/fp.vue?macro=true";
import { default as legalsTXRTijcZBTADF6JJ6SGGk8GUEpWRuSIHSseG9zt4GMMeta } from "/Users/chris/Projects/autoz/dealerme/pages/legal.vue?macro=true";
import { default as loginr4hoOjdOYoqssSQX_Iaw9Ya_452GasyEXw_7NnSMeGXW8Meta } from "/Users/chris/Projects/autoz/dealerme/pages/login.vue?macro=true";
import { default as compareHf8T22VAD2zLnB75Z_v1c1HE1C_45NwxSiiGQBTxdCBS8Meta } from "/Users/chris/Projects/autoz/dealerme/pages/compare.vue?macro=true";
import { default as contactCvaTTeiM3nGkoO1vodyB2XJaMKBhryAVqheTRzVVmMMMeta } from "/Users/chris/Projects/autoz/dealerme/pages/contact.vue?macro=true";
import { default as reviewsqn0ELnp8XqxSgfQTz7RHDUCTNYVdi8EHjdGJ4oLLFfIMeta } from "/Users/chris/Projects/autoz/dealerme/pages/reviews.vue?macro=true";
import { default as _91_46_46_46slug_93XcxBDK07xz3UDYxo4FKaqSTOYmfFi5VB4kx071ES56AMeta } from "/Users/chris/Projects/autoz/dealerme/pages/[...slug].vue?macro=true";
import { default as index1_0YSmZulJaNVDlIGjRDlIYxY4_45EkHNNjciIu4C2f_45EMeta } from "/Users/chris/Projects/autoz/dealerme/pages/blog/index.vue?macro=true";
import { default as _91slug_9397ezQQPEi3NVVv7WnclKZaJfbxWeShVecSYC3sDYGQ8Meta } from "/Users/chris/Projects/autoz/dealerme/pages/blog/[slug].vue?macro=true";
import { default as indexvzSpVHGJV78vRJx0Uqxwkn0U_GzhJFo_EArTr7oT3u0Meta } from "/Users/chris/Projects/autoz/dealerme/pages/staff/index.vue?macro=true";
import { default as terms1wRzD8Y04k_RR5RTGGp3E79nb7J_45sGRLgwxayy56aCkMeta } from "/Users/chris/Projects/autoz/dealerme/pages/(legal)/terms.vue?macro=true";
import { default as indexko4kF7OidnZrobCdNHpnjrGgBEoyEqOJGKYBLZKxhy8Meta } from "/Users/chris/Projects/autoz/dealerme/pages/careers/index.vue?macro=true";
import { default as _91slug_934_H3gZFh9ine4Ts109wno7KQkkr8OwhfpA12DAqeQJQMeta } from "/Users/chris/Projects/autoz/dealerme/pages/careers/[slug].vue?macro=true";
import { default as schedule5VH9KZjxBtLXS2QLfiPNshIBqvAmxFww1UGf_45fnbtCIMeta } from "/Users/chris/Projects/autoz/dealerme/pages/parts/schedule.vue?macro=true";
import { default as indexQ_y_45kn29QDOmP7bkX99W23zw6lMnF_NXOf1nfiS7w68Meta } from "/Users/chris/Projects/autoz/dealerme/pages/equipment/index.vue?macro=true";
import { default as _91slug_93T0XQ_45DwhfMouq40Awflfeg0pAhBbqG1Sb2n4tlGOt4QMeta } from "/Users/chris/Projects/autoz/dealerme/pages/for-sale/[slug].vue?macro=true";
import { default as index1lFkgIzwEGQ_457yJWK8F_45DqyfGJ8rAl4H9yLsOI9tx5QMeta } from "/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue?macro=true";
import { default as indexzOLCr3taSIWZoMX3LJousdruxGzgJ2hsCA2vkabhJScMeta } from "/Users/chris/Projects/autoz/dealerme/pages/locations/index.vue?macro=true";
import { default as indexwy_kXbjo5gdkaW20XC07XAg7tHB72k4BGipGFLjQtb0Meta } from "/Users/chris/Projects/autoz/dealerme/pages/directions/index.vue?macro=true";
import { default as _91slug_93zIJ_455_8gdeOe3oq6_45ac4qMdvOyf8ke89jmqJy3LihzYMeta } from "/Users/chris/Projects/autoz/dealerme/pages/locations/[slug].vue?macro=true";
import { default as indexYlvQ7lynpcf4W1OA24TbwBO5TuycV19fz5EBnpeFHqcMeta } from "/Users/chris/Projects/autoz/dealerme/pages/oem-promos/index.vue?macro=true";
import { default as scheduleKx8IjhOZsUZU0_gFxrguhjyl6zjuIUFDv41Rr9zpcKcMeta } from "/Users/chris/Projects/autoz/dealerme/pages/service/schedule.vue?macro=true";
import { default as _91slug_932jtuLn1zO0WU_45wPo_45uEbELg_Z72ex5WoC2865rxBTYgMeta } from "/Users/chris/Projects/autoz/dealerme/pages/oem-promos/[slug].vue?macro=true";
import { default as car_45loan_45calculatoryZg3zozsEtCx_45kIXbUiYV3XlPK7w2Fk7X7hrtkXnVsoMeta } from "/Users/chris/Projects/autoz/dealerme/pages/car-loan-calculator.vue?macro=true";
import { default as privacy_45policyuAPhel8oAwnR6nyt09MTefb9HCWQk9zo5ntmsGITwOoMeta } from "/Users/chris/Projects/autoz/dealerme/pages/(legal)/privacy-policy.vue?macro=true";
import { default as privacy_45requestsiOO2JDYx3_lc20JG1emryWppASIqDzQQbxhxvyQUI4MMeta } from "/Users/chris/Projects/autoz/dealerme/pages/(legal)/privacy-requests.vue?macro=true";
import { default as indexW6_ed6r3VrVvuG39BSpi0m0d1DYfBBDxqddaNaaEXzUMeta } from "/Users/chris/Projects/autoz/dealerme/pages/finance-application/index.vue?macro=true";
import { default as personal_45consumer_45informationNgi1GB_g8BjzgsyhrSFQkgVGjeiK70dTNAChW0yJcNYMeta } from "/Users/chris/Projects/autoz/dealerme/pages/(legal)/personal-consumer-information.vue?macro=true";
import { default as DirectionSlugPage6Kt6Vab39CGLIs7vAdU69h7q20SIeWd1an9C9m0mNIsMeta } from "/Users/chris/Projects/autoz/dealerme/components/Directions/DirectionSlugPage.vue?macro=true";
export default [
  {
    name: "fp___en",
    path: "/fp",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/fp.vue")
  },
  {
    name: "fp___es",
    path: "/es/fp",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/fp.vue")
  },
  {
    name: "legal___en",
    path: "/legal",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/legal.vue")
  },
  {
    name: "legal___es",
    path: "/es/legal",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/legal.vue")
  },
  {
    name: "login___en",
    path: "/login",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/login.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/login.vue")
  },
  {
    name: "compare___en",
    path: "/compare",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/compare.vue")
  },
  {
    name: "compare___es",
    path: "/es/compare",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/compare.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/contact.vue")
  },
  {
    name: "contact___es",
    path: "/es/contact",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/contact.vue")
  },
  {
    name: "reviews___en",
    path: "/reviews",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/reviews.vue")
  },
  {
    name: "reviews___es",
    path: "/es/reviews",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/reviews.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93XcxBDK07xz3UDYxo4FKaqSTOYmfFi5VB4kx071ES56AMeta || {},
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/[...slug].vue")
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    meta: _91_46_46_46slug_93XcxBDK07xz3UDYxo4FKaqSTOYmfFi5VB4kx071ES56AMeta || {},
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/[...slug].vue")
  },
  {
    name: "blog___en",
    path: "/blog",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/blog/index.vue")
  },
  {
    name: "blog___es",
    path: "/es/blog",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/blog/index.vue")
  },
  {
    name: "blog-slug___en",
    path: "/blog/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___es",
    path: "/es/blog/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/blog/[slug].vue")
  },
  {
    name: "staff___en",
    path: "/staff",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/staff/index.vue")
  },
  {
    name: "staff___es",
    path: "/es/staff",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/staff/index.vue")
  },
  {
    name: "terms___en",
    path: "/terms",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/(legal)/terms.vue")
  },
  {
    name: "terms___es",
    path: "/es/terms",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/(legal)/terms.vue")
  },
  {
    name: "careers___en",
    path: "/careers",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/careers/index.vue")
  },
  {
    name: "careers___es",
    path: "/es/careers",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/careers/index.vue")
  },
  {
    name: "careers-slug___en",
    path: "/careers/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/careers/[slug].vue")
  },
  {
    name: "careers-slug___es",
    path: "/es/careers/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/careers/[slug].vue")
  },
  {
    name: "parts-schedule___en",
    path: "/parts/schedule",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/parts/schedule.vue")
  },
  {
    name: "parts-schedule___es",
    path: "/es/parts/schedule",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/parts/schedule.vue")
  },
  {
    name: "equipment___en",
    path: "/equipment",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/equipment/index.vue")
  },
  {
    name: "equipment___es",
    path: "/es/equipment",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/equipment/index.vue")
  },
  {
    name: "for-sale-slug___en",
    path: "/for-sale/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/for-sale/[slug].vue")
  },
  {
    name: "for-sale-slug___es",
    path: "/es/for-sale/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/for-sale/[slug].vue")
  },
  {
    name: "inventory___en",
    path: "/inventory",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue")
  },
  {
    name: "inventory___es",
    path: "/es/inventory",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue")
  },
  {
    name: "locations___en",
    path: "/locations",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/locations/index.vue")
  },
  {
    name: "locations___es",
    path: "/es/locations",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/locations/index.vue")
  },
  {
    name: "directions___en",
    path: "/directions",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/directions/index.vue")
  },
  {
    name: "directions___es",
    path: "/es/directions",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/directions/index.vue")
  },
  {
    name: "locations-slug___en",
    path: "/locations/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/locations/[slug].vue")
  },
  {
    name: "locations-slug___es",
    path: "/es/locations/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/locations/[slug].vue")
  },
  {
    name: "oem-promos___en",
    path: "/oem-promos",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/oem-promos/index.vue")
  },
  {
    name: "oem-promos___es",
    path: "/es/oem-promos",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/oem-promos/index.vue")
  },
  {
    name: "service-schedule___en",
    path: "/service/schedule",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/service/schedule.vue")
  },
  {
    name: "service-schedule___es",
    path: "/es/service/schedule",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/service/schedule.vue")
  },
  {
    name: "oem-promos-slug___en",
    path: "/oem-promos/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/oem-promos/[slug].vue")
  },
  {
    name: "oem-promos-slug___es",
    path: "/es/oem-promos/:slug()",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/oem-promos/[slug].vue")
  },
  {
    name: "car-loan-calculator___en",
    path: "/car-loan-calculator",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/car-loan-calculator.vue")
  },
  {
    name: "car-loan-calculator___es",
    path: "/es/car-loan-calculator",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/car-loan-calculator.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/(legal)/privacy-policy.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/(legal)/privacy-policy.vue")
  },
  {
    name: "privacy-requests___en",
    path: "/privacy-requests",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/(legal)/privacy-requests.vue")
  },
  {
    name: "privacy-requests___es",
    path: "/es/privacy-requests",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/(legal)/privacy-requests.vue")
  },
  {
    name: "finance-application___en",
    path: "/finance-application",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/finance-application/index.vue")
  },
  {
    name: "finance-application___es",
    path: "/es/finance-application",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/finance-application/index.vue")
  },
  {
    name: "personal-consumer-information___en",
    path: "/personal-consumer-information",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/(legal)/personal-consumer-information.vue")
  },
  {
    name: "personal-consumer-information___es",
    path: "/es/personal-consumer-information",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/(legal)/personal-consumer-information.vue")
  },
  {
    name: "inventory-make-body-style___en",
    path: "/inventory/:makeOrBodyStyle",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue")
  },
  {
    name: "inventory-make-body-style___es",
    path: "/es/inventory/:makeOrBodyStyle",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue")
  },
  {
    name: "category___en",
    path: "/:category([\\w-]+-for-sale)",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue")
  },
  {
    name: "category___es",
    path: "/es/:category([\\w-]+-for-sale)",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue")
  },
  {
    name: "category-make-body-style___en",
    path: "/:category([\\w-]+-for-sale)/:makeOrBodyStyle",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue")
  },
  {
    name: "category-make-body-style___es",
    path: "/es/:category([\\w-]+-for-sale)/:makeOrBodyStyle",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/inventory/index.vue")
  },
  {
    name: "directions-slug-page___en",
    path: "/:slug(used-car-dealership-near-[\\w-]+)",
    component: () => import("/Users/chris/Projects/autoz/dealerme/components/Directions/DirectionSlugPage.vue")
  },
  {
    name: "directions-slug-page___es",
    path: "/es/:slug(used-car-dealership-near-[\\w-]+)",
    component: () => import("/Users/chris/Projects/autoz/dealerme/components/Directions/DirectionSlugPage.vue")
  },
  {
    name: "storyblok-page___en",
    path: "/pages/:slug",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/[...slug].vue")
  },
  {
    name: "storyblok-page___es",
    path: "/es/pages/:slug",
    component: () => import("/Users/chris/Projects/autoz/dealerme/pages/[...slug].vue")
  }
]